import { render, staticRenderFns } from "./QLTipiSegnalazione.vue?vue&type=template&id=0dfdc5b4&scoped=true&"
import script from "./QLTipiSegnalazione.vue?vue&type=script&lang=js&"
export * from "./QLTipiSegnalazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfdc5b4",
  null
  
)

export default component.exports